<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    location="right"
    origin="center center"
    transition="fade-transition"
    style="overflow-y: auto; bottom: 0;"
    content-class="notifications-menu"
    eager
  >
    <template v-slot:activator="{ props: menuActivatorProps }">
      <v-tooltip location="bottom" z-index="1200" :aria-label="$t('menus.topBars.notifications')">
        <template v-slot:activator="{ props: tooltipActivatorProps }">
          <v-btn
            v-bind="{ ...menuActivatorProps, ...tooltipActivatorProps }"
            class="mx-1 px-0"
            height="48px"
            :width="$vuetify.display.xs ? '36px' : '48px'"
            :elevation="0"
            rounded="large"
            icon
            style="border-radius: 10px;"
            :aria-label="$t('menus.topBars.notifications')"
          >
            <v-icon class="mr-0" size="28px" :color="notificationColor">mdi-bell</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('menus.topBars.notifications') }}</span>
      </v-tooltip>
    </template>

    <v-card class="notifications-list-container">
      <v-card-text>
        <NotificationsList />
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script>
import { useAuthStore } from '@/stores/AuthStore.js'
import { usePodStore } from '@/stores/PodStore.js'
import { useNotificationStore } from '@/stores/NotificationStore.js'
import NotificationsList from './NotificationsList.vue'

export default {
  name: "NotificationsMenu",
  components: {
    NotificationsList,
  },
  data() {
    return {
      menu: false,
      notificationColor: "default",
    };
  },
  watch: {
    menu: function(newValue) {
      if (newValue) {
        this.refreshNotifications();
        const podStore = usePodStore();
        if (podStore.quickSwitcherVisible) {
          podStore.toggleQuickSwitcher();
        }
      }
    },
    newNotification: function(newValue) {
      this.updateNotificationColor(newValue);
    }
  },
  methods: {
    refreshNotifications() {
      const authStore = useAuthStore();
      const accessPointId = authStore.rootNodeId;
      const notificationStore = useNotificationStore();
      notificationStore.refreshNotifications({ accessPointId });
    },
    updateNotificationColor(notification) {
      // If tenantId is set, only show notifications for that tenant.
      if (notification?.tenantId) {
        const authStore = useAuthStore();
        const tenantId = authStore.getActiveTenantId;
        // Check if the message is for the active tenant.
        if (tenantId !== notification.tenantId) {
          return;
        }
      }
      if (notification?.type === 2 && this.notificationColor !== 'error') {
        this.notificationColor = 'error';
      } else if (notification?.type === 1 && this.notificationColor !== 'primary') {
        this.notificationColor = 'primary';
      } else if (this.notificationColor !== 'default') {
        this.notificationColor = 'default';
      }
    }
  },
  computed: {
    newNotification: function() {
      const notificationStore = useNotificationStore();
      return notificationStore.newNotification;
    },
  }
}
</script>

<style lang="scss" scoped>
:deep(.notifications-menu) {
  width: 500px;
  top: 80px !important;
  bottom: 5px !important;
  border-radius: 8px;

  > .notifications-list-container {
    min-height: 100%;
  }
}

@media only screen and (max-width: 600px) {
  :deep(.notifications-menu) {
    min-width: 100%;
    top: 60px !important;
    left: 0 !important;
    right: 0 !important;
  }
}
</style>
